import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { useBrands } from '../hooks/useBrands';
import { SPORTS } from '../utils/sports';
import './Footer.css';

function Footer() {
  const { brands } = useBrands();

  return (
    <footer className="site-footer" data-topbar-surface="dark">
      <div className={`site-footer-inner${brands.length > 0 ? ' site-footer-inner--with-brands' : ''}`}>
        <div className="site-footer-brand">
          <Link to="/" className="site-footer-logo" aria-label="Laurenti Apparel home">
            <BrandLogo />
          </Link>
          <p>
            Licensed kit, edited into a quieter wardrobe. Fewer drops. Sharper
            standards.
          </p>
        </div>

        <div className="site-footer-col">
          <p className="site-footer-label">Sports</p>
          <ul>
            {SPORTS.map(sport => (
              <li key={sport.slug}>
                <Link to={`/sports/${sport.slug}`}>{sport.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {brands.length > 0 && (
          <div className="site-footer-col">
            <p className="site-footer-label">Brands</p>
            <ul>
              {brands.map(brand => (
                <li key={brand.slug}>
                  <Link to={`/brands/${brand.slug}`}>{brand.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="site-footer-col">
          <p className="site-footer-label">Shop</p>
          <ul>
            <li>
              <Link to="/shop">All products</Link>
            </li>
            <li>
              <Link to="/cart">Bag</Link>
            </li>
            <li>
              <Link to="/orders">Orders</Link>
            </li>
            <li>
              <Link to="/login">Account</Link>
            </li>
          </ul>
        </div>

        <div className="site-footer-col">
          <p className="site-footer-label">House</p>
          <ul>
            <li>
              <Link to="/shipping">Shipping</Link>
            </li>
            <li>
              <Link to="/returns">Returns</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer-bar">
        <span>© {new Date().getFullYear()} Laurenti Apparel</span>
        <span>Quiet authority. Pitch-born, wardrobe-cut.</span>
      </div>
    </footer>
  );
}

export default Footer;
